import { SpellShardIconGenerator } from "../assets/spellShardIcon.js";

import { Shard } from "./shard.js"; // Import the class

export class spellHandler {
    constructor(params) {
        this.spellShardInventory = new Map();
        this.iconGenerator = new SpellShardIconGenerator();
        this.spellShardsByElement = {};

        this.spellGrids = {
            all: {
                size: 7,
                usedGridSlots: new Map(),
                equippedShardOrigins: new Map(),
                equippedShards: new Map()
            }
        };

        this.createFirstShard();
    }

    printAllShards() {
        if (this.spellShardInventory) {
            for (const [key, value] of this.spellShardInventory) {
                //console.log(`${key}: ${value.toJSON()}`);
            }
        }
    }

    initSpellGrids(elementName, calculatedSize) {
        if (!this.spellGrids[elementName]) {
            this.spellGrids[elementName] = {
                size: calculatedSize,
                usedGridSlots: new Map(),        
                equippedShardOrigins: new Map(), 
                equippedShards: new Map() 
            };
        } else {
            this.spellGrids[elementName].size = calculatedSize;
        }
    }

    calculateSpellStats(elementName) {
        // Initialize default fallback stats
        const stats = {
            totalPower: 0,
            totalMPCost: 0,
            totalSpeed: 0,
            shardCount: 0
        };

        const targetGrid = this.spellGrids[elementName];
        if (!targetGrid) {
            console.warn(`Grid for element "${elementName}" not found. Returning zeroed stats.`);
            return stats;
        }

        // Loop over every active shard instance currently assigned to this grid
        targetGrid.equippedShards.forEach((shardInstance) => {
            // Accumulate our stats cleanly using the new Shard class property definitions
            stats.totalPower += shardInstance.stats.basePower || 0;
            stats.totalMPCost += shardInstance.stats.mpCost || 0;
            stats.totalSpeed += shardInstance.stats.castSpeed || 0;
            stats.shardCount++;
        });

        // Optional: Round the speed total to 2 decimal places to avoid standard 
        // JavaScript floating-point errors (e.g. 1.2 + 0.8 ending up as 2.0000000000004)
        stats.totalSpeed = Number(stats.totalSpeed.toFixed(2));

        return stats;
    }

    /**
     * Scans all elemental spell grids, compiling active shards into consolidated spells.
     * Returns an array of spell objects representing any grid layout with at least 1 shard.
     */
    getActiveGridSpells() {
        const compiledSpells = [];

        for (const [elementName, grid] of Object.entries(this.spellGrids)) {
            // Only process grids that have shards actively slotted inside them
            if (grid.equippedShards.size > 0) {
                const combinedStats = this.calculateSpellStats(elementName);
                
                compiledSpells.push({
                    id: `hunting-spell-${elementName}`,
                    elementName: elementName,
                    shardCount: combinedStats.shardCount,
                    stats: {
                        basePower: combinedStats.totalPower,
                        castSpeed: combinedStats.totalSpeed,
                        mpCost: combinedStats.totalMPCost
                    }
                });
            }
        }

        return compiledSpells;
    }


    emptySpellGrid(elementName) {
        const targetGrid = this.spellGrids[elementName];
        if (!targetGrid) return false;

        targetGrid.equippedShards.forEach((shardInstance, uuid) => {
            this.addSpellShard(uuid, shardInstance);
        });

        targetGrid.usedGridSlots.clear();
        targetGrid.equippedShardOrigins.clear();
        targetGrid.equippedShards.clear();
    }

    equipShard(uuid, gridElement, gridIndex) {
        const shard = this.getSpellShard(uuid);
        if (!shard) return false;

        const shardSize = shard.tier || 1;
        const [originX, originY] = gridIndex;

        const targetGrid = this.spellGrids[gridElement];
        if (!targetGrid) {
            console.error(`Grid for element "${gridElement}" has not been initialized yet.`);
            return false;
        }

        const maxGridSize = targetGrid.size;

        if (originX < 0 || originY < 0 || originX + shardSize > maxGridSize || originY + shardSize > maxGridSize) {
            console.log("Placement failed: Footprint exceeds grid boundary parameters.");
            return false;
        }

        const previousOrigin = targetGrid.equippedShardOrigins.get(uuid);
        if (previousOrigin) {
            for (let x = 0; x < shardSize; x++) {
                for (let y = 0; y < shardSize; y++) {
                    const key = `${previousOrigin.x + x},${previousOrigin.y + y}`;
                    if (targetGrid.usedGridSlots.get(key) === uuid) {
                        targetGrid.usedGridSlots.delete(key);
                    }
                }
            }
        }

        for (let x = 0; x < shardSize; x++) {
            for (let y = 0; y < shardSize; y++) {
                const key = `${originX + x},${originY + y}`;
                if (targetGrid.usedGridSlots.has(key)) {
                    console.log(`Placement failed: Target cell block ${key} is already occupied.`);
                    if (previousOrigin) {
                        this.placeShard(targetGrid, uuid, previousOrigin.x, previousOrigin.y, shardSize);
                    }
                    return false;
                }
            }
        }

        this.placeShard(targetGrid, uuid, originX, originY, shardSize);
        targetGrid.equippedShards.set(uuid, shard);

        console.log(`Successfully allocated shard ${uuid} to "${gridElement}" grid position [${originX}, ${originY}]`);
        return true;
    }

    placeShard(targetGrid, uuid, startX, startY, size) {
        targetGrid.equippedShardOrigins.set(uuid, { x: startX, y: startY });
        for (let x = 0; x < size; x++) {
            for (let y = 0; y < size; y++) {
                this.removeSpellShard(uuid);
                targetGrid.usedGridSlots.set(`${startX + x},${startY + y}`, uuid);
            }
        }
    }

    addSpellPacket(generatedSpells) {
        for (const [id, rawSpell] of Object.entries(generatedSpells)) {
            this.addSpellShard(id, rawSpell);
        }
    }

    createFirstShard() {
        if (!this.spellShardInventory || this.spellShardInventory.has("firstSpellUUID")) return;

        let spellObj = {
            element: "fire",
            tier: 1,
            size: 1
        }

        let uuid = "firstSpellUUID"
        this.addSpellShard(uuid, spellObj);
    }

    // UPDATED: Standardized inputs to safely wrap raw objects into Shard class instances
    addSpellShard(uuid, spellObject) {
        let shardInstance;

        if (spellObject instanceof Shard) {
            shardInstance = spellObject;
        } else {
            // Converts raw JSON payload from server into instantiated Shard class
            const tier = spellObject.tier || spellObject.size || 1;
            shardInstance = new Shard(uuid, spellObject.element, tier);
        }

        this.spellShardInventory.set(uuid, shardInstance);
        this.initSpellShardByElement(shardInstance.element);
        this.spellShardsByElement[shardInstance.element].add(uuid);

        this.printAllShards();
    }

    removeSpellShard(uuid) {
        const spellToRemove = this.spellShardInventory.get(uuid);
        if (spellToRemove) {
            this.spellShardInventory.delete(uuid);
            this.spellShardsByElement[spellToRemove.element]?.delete(uuid);
        }
    }

    initSpellShardByElement(element) {
        if (!this.spellShardsByElement[element]) {
            this.spellShardsByElement[element] = new Set();
        }
    }

    getAllElementSpellShards(element, sortBy = 'tier') {
        this.initSpellShardByElement(element);
        const shards = Array.from(this.spellShardsByElement[element])
            .map(uuid => this.spellShardInventory.get(uuid))
            .filter(Boolean);

        return shards.sort((a, b) => b[sortBy] - a[sortBy]);
    }

    getAllSpells(sortBy = 'tier') {
        const allSpells = Array.from(this.spellShardInventory.values());
        return allSpells.sort((a, b) => b[sortBy] - a[sortBy]);
    }

    getSpellShard(uuid) {
        return this.spellShardInventory.get(uuid);
    }

    drawInventory(slots, activeSpells) {
        slots.forEach(slot => {
            slot.innerHTML = ''; 
            slot.removeAttribute('data-spell-id');
        });

        activeSpells.forEach((spellObj, index) => {
            if (index >= slots.length) return;
            const targetSlot = slots[index];

            const svgIcon = this.iconGenerator.getIcon(spellObj.spellUUID, spellObj);
            targetSlot.appendChild(svgIcon);
            targetSlot.setAttribute('data-spell-id', spellObj.spellUUID);
        });
    }

    // UPDATED: Highly optimized flat-array saving formats for shards!
    saveToData() {
        const serializedGrids = {};

        for (const [elementName, grid] of Object.entries(this.spellGrids)) {
            // Map equipped shards into efficient flat arrays as well
            const equippedArray = Array.from(grid.equippedShards.entries()).map(([uuid, shardInstance]) => {
                return [uuid, shardInstance.toJSON()];
            });

            serializedGrids[elementName] = {
                size: grid.size,
                usedGridSlots: Array.from(grid.usedGridSlots.entries()),
                equippedShardOrigins: Array.from(grid.equippedShardOrigins.entries()),
                equippedShards: equippedArray
            };
        }

        return { 
            // Invokes .toJSON() on each class instance, saving only 3 values per shard
            spellCache: Array.from(this.spellShardInventory.entries()).map(([uuid, shardInstance]) => {
                return [uuid, shardInstance.toJSON()];
            }),
            spellGrids: serializedGrids 
        };
    }

    // UPDATED: Safely reconstructs real Shard class instances on load
    loadFromData(data) {
        if (!data) return;

        // Recover unequipped items
        if (data.spellCache) {
            this.spellShardInventory = new Map();
            this.spellShardsByElement = {};

            data.spellCache.forEach(([uuid, rawArray]) => {
                const [spellUUID, element, tier] = rawArray;
                const restoredShard = new Shard(spellUUID, element, tier);
                this.addSpellShard(uuid, restoredShard); 
            });
        }

        // Recover equipped layout matrices
        if (data.spellGrids) {
            this.spellGrids = {};

            for (const [elementName, savedGrid] of Object.entries(data.spellGrids)) {
                // Reconstruct equipped Shard instances in place
                const reconstructedEquippedMap = new Map();
                savedGrid.equippedShards.forEach(([uuid, rawArray]) => {
                    const [spellUUID, element, tier] = rawArray;
                    reconstructedEquippedMap.set(uuid, new Shard(spellUUID, element, tier));
                });

                this.spellGrids[elementName] = {
                    size: savedGrid.size,
                    usedGridSlots: new Map(savedGrid.usedGridSlots),
                    equippedShardOrigins: new Map(savedGrid.equippedShardOrigins),
                    equippedShards: reconstructedEquippedMap
                };
            }
        }
    }
}